import React  from 'react';
import { Link } from 'react-router-dom';
import classNames from 'classnames';
import { Menubar } from 'primereact/menubar';

import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import { useHistory } from 'react-router-dom';
import { useDispatch } from "react-redux";
export const AppTopbar = (props) => {
    const history = useHistory();
    const dispatch = useDispatch();
    const items = [
        {
            label: 'Products',
             command: () => history.push('/')
            
        },
        {
            label: 'Process',
            command: () => history.push('/userprocess')
        },
        {
            label: 'Social Media',
            command: () => history.push('/usersocialmedia')
        },
        {
            label: 'Complaints',
            command: () => history.push('/usercomplaint')
        },
        {
            label: 'FAQs',
            command: () => history.push('/userfaq')
        },
        // {
        //     label: 'Chat',
        //     command: () => history.push('/userchat')
        // }
    ];
  
    const signoutConfirm = () => {
        localStorage.clear("user")
        // confirmDialog({
        //     message: "Are you sure you want to Logout?",
        //     icon: "pi pi-exclamation-triangle",
        //     header: "Confirmation",
        //     acceptClassName: "p-button p-button p-button-sm width-80",
        //     accept: () => {
        //         //dispatch(logout());
        //         localStorage.clear("user")
        //        // history.push("/"); // Redirect to the home page
        //     },
        //     reject,
        // });
    };
   
    const reject = () => {};
    return (
        <div className="layout-topbar">
            <Link to="/" className="layout-topbar-logo">
                {/* <img src={props.layoutColorMode === 'light' ? 'assets/layout/images/logo-dark.svg' : 'assets/layout/images/logo-white.svg'} alt="logo"/> */}
                <span>Z-Product</span>
            </Link>
            {/* <button type="button" className="p-link  layout-menu-button layout-topbar-button" onClick={props.onToggleMenuClick}>
                <i className="pi pi-bars"/>
            </button> */}

            <button type="button" className="p-link layout-topbar-menu-button layout-topbar-button" onClick={props.onMobileTopbarMenuClick}>
                <i className="pi pi-ellipsis-v" />
            </button>
            <Menubar model={items}
            
             />
                <ul className={classNames("layout-topbar-menu lg:flex origin-top", {'layout-topbar-menu-mobile-active': props.mobileTopbarMenuActive })}>
                    <li>
                        <button className="p-link layout-topbar-button" onClick={props.onMobileSubTopbarMenuClick}>
                            <i className="pi pi-calendar"/>
                            <span>Events</span>
                        </button>
                    </li>
                    <li>
                        <button className="p-link layout-topbar-button" onClick={props.onMobileSubTopbarMenuClick}>
                            <i className="pi pi-cog"/>
                            <span>Settings</span>
                        </button>
                    </li>
                    <li>
                        <button className="p-link layout-topbar-button" onClick={ signoutConfirm()}>
                            <i className="pi pi-user"/>
                            <span >Profile</span>
                        </button>
                    </li>
                </ul>
        </div>
    );
}
